<template>
    <div class="search-panel-radio">
        <div
            v-for="item in filter.items"
            :key="item.id"
            class="search-panel-radio__btn"
        >
            <input
                type="radio"
                :id="`${filter.category}[${item.id}]`"
                :name="filter.category"
                :checked="item.checked"
                :disabled="item.disabled"
                :value="item.id"
                class="search-panel-radio__btn-input"
            >
            <label
                class="search-panel-radio__btn-label"
                :for="`${filter.category}[${item.id}]`"
            >
                <span class="search-panel-radio__btn-text-wrapper">
                    <span class="search-panel-radio__btn-text">
                        {{ item.title }}
                    </span>
                    <span class="search-panel-radio__btn-text search-panel-radio__btn-text-duplicate">
                        {{ item.title }}
                    </span>
                </span>
            </label>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RadioButtons',

    props: ['filter'],

    methods: {
        changeRadio(event) {
            this.$emit('change', event.target.value);
        }
    }
};
</script>

<style lang="scss">
@import 'RadioButtons';
</style>
